<template>
    <div>
        <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
</template>

<script>
import {getHref} from '@/utils/util'
import { Loading,Toast } from 'vant';
export default {
    created(){
        // setTimeout(()=>{
        //     window.location.href=window.location.origin+window.location.pathname+"#/login"; 
        // },2000);
        this.getUserInfo();
    },
    methods:{
        getUserInfo(){
            //1.获取code
            let href=window.location.href;
            let arr=href.split("?")[1].split("#")[0].split("&");
            let reg=/code/;
            let reg2=/state/;
            let code;
            let state;  //2:普通全员注册，1:经纪人/渠道代理
            arr.forEach(element => {
                let arr2=element.split("=");
                if(reg.test(arr2[0])){
                    code=arr2[1]
                }else if(reg2.test(arr2[0])){
                    state=arr2[1]
                }
            });
            // 2.获取用户信息
            this.$https.fetchPost("Wechat/getWxUserInfo",{"code":code,"state":state})
            .then(result=>{
                let data=result.data;
                //手机为空的话，弹出绑定手机页面，进行手机绑定
                if(data.code==1){
                    let userInfo=data.data
                    this.$store.commit("SET_TOKEN",userInfo);
                    if(userInfo.mobile==""){
                        this.goAddInfo(userInfo.user_type);
                    }else{
                        window.location.href=window.location.origin+window.location.pathname+"#/login"; //这样写为了跳转时在#前穿过来的参数                       
                        // this.$router.push("/login");
                    }
                }
            })
        },
        //跳转到对应信息补充页面
        goAddInfo(e){
            if(e=="2"){
                this.$router.push("/phone")
            }else{
                this.$router.push("/agentInfo")
            }
        }

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/login/transfer.vue